var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 41,
    viewBox: "0 0 98 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4447 25.958L15.9227 25.328L14.0327 19.784L18.5267 16.802H13.0247L11.0507 10.838L8.78266 11.51L7.01866 16.802H2.94466L1.47466 17.222L5.80066 20.372L4.07866 25.412L6.43066 25.328L9.58066 22.976L13.4447 25.958ZM14.7887 24.152L10.8407 21.212L6.89266 24.152L8.48866 19.658L4.83466 17.306H9.24466L10.8407 12.014L12.4787 17.306H16.8467L13.1927 19.658L14.7887 24.152Z",
    fill: "#C5E3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4447 25.958L54.9227 25.328L53.0327 19.784L57.5267 16.802H52.0247L50.0507 10.838L47.7827 11.51L46.0187 16.802H41.9447L40.4747 17.222L44.8007 20.372L43.0787 25.412L45.4307 25.328L48.5807 22.976L52.4447 25.958ZM53.7887 24.152L49.8407 21.212L45.8927 24.152L47.4887 19.658L43.8347 17.306H48.2447L49.8407 12.014L51.4787 17.306H55.8467L52.1927 19.658L53.7887 24.152Z",
    fill: "#C5E3FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4447 25.958L93.9227 25.328L92.0327 19.784L96.5267 16.802H91.0247L89.0507 10.838L86.7827 11.51L85.0187 16.802H80.9447L79.4747 17.222L83.8007 20.372L82.0787 25.412L84.4307 25.328L87.5807 22.976L91.4447 25.958ZM92.7887 24.152L88.8407 21.212L84.8927 24.152L86.4887 19.658L82.8347 17.306H87.2447L88.8407 12.014L90.4787 17.306H94.8467L91.1927 19.658L92.7887 24.152Z",
    fill: "#C5E3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.f09c6186a8a71e072302dda3123ef413.svg";
export { ForwardRef as ReactComponent };